<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置事件监听</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对一些事件状态信息进行监听，不同的事件对应不同的参数。
		</p>
		<h3 class="doc_main_h3">数据库已注册(可识别)人数监听函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceRegisterDBPersonNumEvent(
        SKFaceRegisteredPersonNumCallback funcRegisteredNumCallback);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
            funcRegisteredNumCallback:对应的监听回调函数（SDK内部提供，由外部实现）
        </p>
        <h3 class="doc_main_h3">回调值</h3>
        <p class="doc_main_p">
            funcRegisteredNumCallback类型为typedef void( __stdcall *SKFaceRegisteredPersonNumCallback ) (int nPersonCount ), nPersonCount: 网络数据库已注册(可识别)人数 。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall FuncPersonNum(int nPersonCount)
{
    printf("RegisteredPersonNumCallback: curPersonNum=%d\n",nPersonCount);
}
int nSetRet = SKFaceRegisterDBPersonNumEvent(FuncPersonNum);
</code></pre>
		<h3 class="doc_main_h3">网络数据库同步进度函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceRegisterNetDBSyncEvent(SKFaceDBSyncProcessCallback funcDBSyncProcessCallback);</code></pre>
		<h3 class="doc_main_h3">参数</h3>
		<p class="doc_main_p">
        	funcDBSyncProcessCallback:对应的监听回调函数（SDK内部提供，由外部实现）
        </p>
        <h3 class="doc_main_h3">回调值</h3>
        <p class="doc_main_p">
            funcDBSyncProcessCallback类型为typedef void(stdcall *SKFaceDBSyncProcessCallback) (int nCurrrentNum, int nSumNum), nCurrentNum:待同步数据中已同步人数，nSumNum:总人数 。
        </p>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall FuncPersonSyncProcess(int nCurrentNum,int nSumNum)
{
    printf("RegisterNetDBSyncEventCallback: curPersonNum=%d,sumPersonNum=%d\n", nCurrentNum,nSumNum);
}
int nSetRet = SKFaceRegisterNetDBSyncEvent(FuncPersonSyncProcess);</code></pre>
		<h3 class="doc_main_h3">有人进入/离开监听函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//人员进入监听函数
bool __stdcall SKFaceRegisterPersonEnterEvent(SKFacePersonEnterCallback funcPersonEnterCallback);
</code></pre>
		<h3 class="doc_main_h3">参数</h3>
		<p class="doc_main_p">
        	funcPersonEnterCallback:对应的监听回调函数（SDK内部提供，由外部实现）
        </p>
        <p class="doc_main_p">
        	funcPersonLeaveCallback:对应的监听回调函数（SDK内部提供，由外部实现）
        </p>
        <h3 class="doc_main_h3">回调值</h3>
        <p class="doc_main_p">
        	funcPersonEnterCallback类型为typedef void(__stdcall *SKFacePersonEnterCallback)(const char *pszPersonInfo), pszPersonInfo:json格式的人员信息，json 格式见下面，监听人进入/离开使用同一类型回调 。回调json示例如下:
        </p>
        <pre class="doc_main_pre"><code class="doc_main_code">//PersonEnterInfo/PersonLeaveInfo Json: 
{
    "Person_id":"161230",
    "Person_Name":"王某某",
    "Groups":[
        {
            "Group_id":"3910",
            "Group_Path":"注册人员（根目录）/盛开互动/"
        }
    ],
    "Person_HeadUrl":"http://skfrm.cn/Uploads/257871.jpg",
    "Age":27,
    "Gender":1,
    "Glasses":0,
    "AgeConfidence":0.99991,
    "GenderConfidence":0.99991,
    "GlassesConfidence":0.999881
}
{
    "Person_id":"L1000000",
    "Person_Name":"[00000001]",
    "Groups":[

    ],
    "Person_HeadUrl":"",
    "Age":2,
    "Gender":2,
    "Glasses":0,
    "AgeConfidence":0.910392,
    "GenderConfidence":0.910392,
    "GlassesConfidence":0.999646
}
//字段含义：
{
    "Person_id": ID,
    "Person_Name": 姓名/陌生人（开启短时记忆）
    "Groups ": 所在人员组的id集合
Group_id：组id
          Group_Path：路径
    "Person_HeadUrl": 大头照地址,
    "Age":年龄,
    "Gender":性别,
    "Glasses":眼镜状态,
    "AgeConfidence": 年龄置信度,
    "GenderConfidence": 性别置信度,
    "GlassesConfidence": 眼镜状态置信度
}</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 人员进入回调函数
void FuncPersonEnter(const char *pszPersonInfo)
{
    printf("EnterPersonInfo:%s\n",pszPersonInfo);
}
// 人员离开回调函数
void FuncPersonLeave(const char *pszPersonInfo)
{
    printf("LeavePersonInfo:%s\n",pszPersonInfo);
}
// 设置人员进入和离开的回调函数
bool bRet1 = SKFaceRegisterPersonEnterEvent(FuncPersonEnter);
bool bRet2 = SKFaceRegisterPersonLeaveEvent(FuncPersonLeave);
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','事件接口','设置事件监听'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/event/setEventMonitor.vue